import en from "./translations/en";

const translation = {
  en: en,
};

export default translation;
